import React, { useEffect, useState } from 'react'
import authFunctions from '../../../../services/userApiServices/authFunctions';
import { getUserInitials, isValidUrl } from '../../../../utils/general';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { setUserProfileImage } from '../../../../state/actions/user';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderTitle } from '../../../../state/actions/layout';
import { removeBot } from '../../../../state/actions/domain';
import { setHideDefaultHomepageBot } from '../../../../state/actions/bot';


const UserProfile = ({ handleLogout }) => {
    const [userInitials, setUserInitials] = useState("");
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const userProfileImage = useSelector((state) => state.user.profileImage);
    const [profilePic, setProfilePic] = useState(null);
    const [activeMenu, setActiveMenu] = useState("");


    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (userProfileImage) {
            setProfilePic(userProfileImage);
        }
    }, [userProfileImage]);


    useEffect(() => {
        try {
            const userString = localStorage.getItem("user");

            if (!userString) {
                console.log("No user found in localStorage");
                return;
            }

            let user;
            try {
              user = JSON.parse(userString);
            } catch (e) {
              console.error("Failed to parse user data:", e);
              return;
            }
            const userId = user.userId;
            const fullName = user?.userName || "";

            const fetchProfilePic = async () => {
                try {
                    const profilePicUrl = authFunctions.getUserProfilePic(userId);
                    const response = await fetch(profilePicUrl);

                    if (response.ok) {
                        setProfilePic(profilePicUrl);
                        dispatch(setUserProfileImage(profilePicUrl));
                    } else {
                        setUserInitials(getUserInitials(fullName));
                    }
                } catch (err) {
                    console.error("Error fetching profile picture:", err);
                    setUserInitials(getUserInitials(fullName));
                }
            };

            if (userProfileImage) {
                setProfilePic(userProfileImage);
            }
            else {
                fetchProfilePic();
            }
        } catch (error) {
            console.log("Error parsing user or fetching data:", error);
        }
    }, []);

    const handleOpenDropdown = (option) => {
        if (option === "profile") {
            dispatch(setHeaderTitle('My Profile'))
            handleNavigate("/app/my-profile")
        } else if (option === "settings") {
            dispatch(setHeaderTitle('Settings'))
            handleNavigate("/app/settings")
        }
        dispatch(setHideDefaultHomepageBot());
        dispatch(removeBot())
    }
    // Handle outside click to close dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            // Check if the clicked element is outside the profile dropdown
            const profileDropdown = event.target.closest('.profile-dropdown-container');

            if (!profileDropdown && showProfileMenu) {
                setShowProfileMenu(false);
            }
        };

        // Add event listener when dropdown is open
        if (showProfileMenu) {
            document.addEventListener('click', handleClickOutside);
        }

        // Cleanup function to remove event listener
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [showProfileMenu]);


    const handleNavigate = (path) => {
        navigate(path);
        dispatch(removeBot())
        setShowProfileMenu(false);
    };


    return (
        <div className="flex items-center sm:space-x-5 space-x-2">
            {/* Profile Dropdown */}
            <div className="relative profile-dropdown-container">
                <button
                    onClick={() => setShowProfileMenu(!showProfileMenu)}
                    className="flex items-center space-x-1 hover:bg-gray-100 rounded-35 p-1 bg-purple-100 w-[68px] h-[36px]"
                >
                    <div
                        style={!profilePic ? { background: "#6ca8ff" } : null}
                        className='w-[30px] h-[30px] rounded-full overflow-hidden border-2 border-white shadow-sm flex items-center justify-center'
                    >
                        {
                            isValidUrl(profilePic) ?
                                <img
                                    src={profilePic}
                                    alt="Profile"
                                    className="w-[100%] h-[100%] object-cover"
                                />
                                :
                                <div className="text-size-14 text-white font-[Figtree]">{userInitials}</div>
                        }
                    </div>
                    <ChevronDown className="w-4 h-4 text-purple-300 stroke-[3.5]" />
                </button>

                {/* Dropdown Menu */}
                {showProfileMenu && (
                    <div className="absolute right-0 mt-2 bg-white rounded-10 shadow-shd-on z-10 overflow-hidden">

                        <div
                            onClick={() => {
                                setActiveMenu("profile")
                                handleOpenDropdown("profile")
                            }}
                            className={`cursor-pointer block px-4 py-2 text-size-14 font-semibold whitespace-nowrap transition-transform duration-200
                                    ${activeMenu === "profile" ? "bg-purple-100 text-black" : "!text-black hover:bg-purple-100"}`}
                        >
                            My Profile
                        </div>
                        <div
                            onClick={() => {
                                setActiveMenu("settings")
                                handleOpenDropdown("settings")
                            }}
                            className={`cursor-pointer block px-4 py-2 text-size-14 font-semibold whitespace-nowrap transition-transform duration-200
                                    ${activeMenu === "settings" ? "bg-purple-100 text-black" : "!text-black hover:bg-purple-100"}`}
                        >
                            Settings
                        </div>
                        <div
                            className="cursor-pointer block px-4 py-2 text-size-14 font-semibold whitespace-nowrap !text-black hover:bg-purple-100 transition-transform duration-200"
                            onClick={handleLogout}
                        >
                            Sign Out
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
};

export default UserProfile